import { AppointmentStatusCodes } from '@lmt/shared-types';
import { addDays, endOfDay, startOfDay } from 'date-fns';

export function getActualNightVisitDate() {
  const dateNow = new Date();
  if (dateNow.getHours() < 11) {
    return addDays(dateNow, -1);
  } else {
    return dateNow;
  }
}

export function isActualVisit(startDate: Date) {
  return startDate.getDate() === getActualNightVisitDate().getDate();
}

export function isNightVisit(startDate: Date, endDate: Date) {
  return startDate.getDate() !== endDate.getDate();
}

export function isActualNightVisit(
  startDate: Date,
  endDate: Date,
  status: AppointmentStatusCodes,
) {
  if (status === AppointmentStatusCodes.Canceled) {
    return false;
  }
  if (!isNightVisit(startDate, endDate)) {
    return false;
  }
  const dateNow = new Date();
  const minEnd = startOfDay(addDays(dateNow, -1));
  const maxStart = endOfDay(addDays(dateNow, 1));
  return (
    endDate.getTime() > minEnd.getTime() &&
    startDate.getTime() < maxStart.getTime()
  );
}

export function isCurrentVisit(
  startDate: Date,
  endDate: Date,
  status: AppointmentStatusCodes,
) {
  if (status === AppointmentStatusCodes.Canceled) {
    return false;
  }
  const dateNow = new Date();
  return startDate < dateNow && endDate > dateNow;
}

export function isLastWeekVisits(date: Date) {
  const today = new Date();
  const previousWeekDate = startOfDay(addDays(today, -7));
  return date > previousWeekDate;
}

export function isIncompleteVisit(
  endDate: Date,
  status: AppointmentStatusCodes,
) {
  const dateNow = new Date();
  return (
    dateNow > endDate &&
    isLastWeekVisits(endDate) &&
    (status === AppointmentStatusCodes.Planned ||
      status === AppointmentStatusCodes.Confirmed)
  );
}

export function isRecentVisit(endDate: Date, status: AppointmentStatusCodes) {
  const dateNow = new Date();
  return (
    dateNow > endDate &&
    isLastWeekVisits(endDate) &&
    (status === AppointmentStatusCodes.Completed ||
      status === AppointmentStatusCodes.Canceled)
  );
}

export function isPlannedVisit(startDate: Date) {
  const dateNow = new Date();
  const dayAfterTomorrow = endOfDay(addDays(dateNow, 2));
  return startDate > dateNow && startDate < dayAfterTomorrow;
}
